import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex min-h-screen flex-col" data-id="element-186">
      <Navbar data-id="element-187" />
      <main className="flex-1" data-id="element-188">
        <Outlet data-id="element-189" />
      </main>
      <Footer data-id="element-190" />
    </div>;
}